import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import CountriesTable from '../components/CountriesTable';

const Countries = () => {
  return (
    <div className="d-flex entire-bg-color">
      <Sidebar />

      <div className="flex-grow-1">
        <DashboardNavbar />
        <div style={{ marginTop: '70px' }}></div>

        <CountriesTable />
      </div>
    </div>
  );
};

export default Countries;
